import styled from "styled-components";

export const Container = styled.div<{ width?: string }>`
  width: ${(props) => props.width ?? "25rem"};
  position: relative;
`;

export const SelectedWrapper = styled.div<{ $withBorder: boolean }>`
  height: 3rem;
  border-radius: 0.25rem;
  border: 1px solid
    ${(props) => (props.$withBorder ? "#DCDCDC" : "transparent")};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 1rem;
  padding-right: 1rem;
  cursor: pointer;
`;

export const TextWrapper = styled.div`
  position: absolute;
  top: -0.5rem;
  left: 0.75rem;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  background-color: #fff;
`;

export const IconWrapper = styled.div<{ $isOpen: boolean }>`
  transform: ${(props) => (props.$isOpen ? "rotate(180deg)" : "")};
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
`;

export const ContentWrapper = styled.div<{ $isVisible: boolean }>`
  border: ${(props) =>
    props.$isVisible ? `1px solid '#DCDCDC'` : `0px solid '#DCDCDC'`};
  padding: ${(props) => (props.$isVisible ? `1rem` : `0 1rem`)};
  opacity: ${(props) => (props.$isVisible ? "1" : "0")};
  max-height: ${(props) => (props.$isVisible ? "20rem" : "0")};
  overflow: hidden;
  transition: max-height 0.3s ease, padding-top 0.6s ease,
    padding-bottom 0.6s ease;
  position: absolute;
  z-index: 10000;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  width: 100%;
  top: 3.5rem;
  background-color: #fff;
  border-radius: 0.5rem;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
  box-sizing: border-box;
`;

export const OptionsWrapper = styled.div<{ maxHeight?: string }>`
  width: 100%;
  top: 3rem;
  background-color: #fff;
  border: 1px solid #dcdcdc;
  border-radius: 0.5rem;
  max-height: auto;
  max-height: ${(props) => props.maxHeight ?? "22.5rem"};
  overflow-y: auto;
`;

export const OptionWrapper = styled.div<{ $isSelected: boolean }>`
  min-height: 2.5rem;
  box-sizing: border-box;
  padding: 1rem;
  width: 100%;
  display: flex;
  align-items: center;
  background-color: ${(props) => (props.$isSelected ? "#DCDCDC" : "white")};

  &:hover {
    background-color: #dcdcdc;
  }
`;

export const ErrorWrapper = styled.div`
  margin-top: 0.5rem;
  padding-left: 1rem;
`;
